var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplyArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0243 9.84234C13.2586 10.0767 13.2586 10.4566 13.0243 10.6909L10.398 13.3171C10.2418 13.4733 10.2418 13.7266 10.398 13.8828C10.5542 14.039 10.8075 14.039 10.9637 13.8828L13.5899 11.2565C14.1367 10.7098 14.1367 9.82339 13.5899 9.27665L10.9637 6.65042C10.8075 6.49422 10.5542 6.49422 10.398 6.65042C10.2418 6.80663 10.2418 7.0599 10.398 7.21611L13.0243 9.84234Z",
    fill: "#5B5C5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4 2C2.17909 2 2 2.17909 2 2.4V8.73327C2 9.83784 2.89543 10.7333 4 10.7333H13.3333C13.5542 10.7333 13.7333 10.5542 13.7333 10.3333C13.7333 10.1124 13.5542 9.93327 13.3333 9.93327H4C3.33726 9.93327 2.8 9.39601 2.8 8.73327V2.4C2.8 2.17909 2.62091 2 2.4 2Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyArrow);
export default __webpack_public_path__ + "static/media/ReplyArrow.d32a66eb1fdee89ca77cd515818ca8c4.svg";
export { ForwardRef as ReactComponent };